/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Badge_IssuingInputs */

const vi_einvoice_badge_issuing = /** @type {(inputs: Einvoice_Badge_IssuingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang đối soát kết quả`)
};

/**

* @param {Einvoice_Badge_IssuingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_badge_issuing = /** @type {((inputs?: Einvoice_Badge_IssuingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Badge_IssuingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_badge_issuing(inputs)
});